import { render, staticRenderFns } from "./WiseTransferCard.vue?vue&type=template&id=62ca10ba&scoped=true&"
import script from "./WiseTransferCard.vue?vue&type=script&lang=js&"
export * from "./WiseTransferCard.vue?vue&type=script&lang=js&"
import style0 from "./WiseTransferCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WiseTransferCard.vue?vue&type=style&index=1&id=62ca10ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ca10ba",
  null
  
)

export default component.exports